import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { PercentageIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/configuration-management/discount-management')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="configurationManagement.discountManagement.crumb" icon={PercentageIcon} />,
      title: <CrumbTitle id="configurationManagement.discountManagement.page.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
